export default __webpack_public_path__ + "static/media/puzzleBackBorder.ed8d3169.png";